import React from 'react'
import { notEmpty } from 'helpers/validators'
import { Row, Col } from 'react-flexbox-grid'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import get from 'lodash/get'

import treeQuery from 'gql/query/cashRegistersTree'
import ContentBlock from 'components/ContentBlock'
import { Form, Text, Select, TextArea } from 'components/forms'
import ClientSelector from 'components/forms/ClientSelector'
import { useQuery } from 'components/graphql'
import Divider from 'components/Divider'
import getPriceLevels from 'config/localServer/query/priceLevelsQuery'

const StyledLabel = styled.p`
	margin: 0 0 3px 0;
    font-size: 12px;
    font-weight: 400;
`

const GeneralParams = ({ data, formData, mutations: { updateItem }, ...rest }) => {
	const [t] = useTranslation()
	const { data: queryRes, queryField } = useQuery(getPriceLevels)
	const priceNames = get(queryRes, [queryField], [])
	const priceOptions = [t('common.strings.none'), ...priceNames].map((name, i) => ({ value: i, label: name }))

	const handleSubmit = values => {
		updateItem(values, {
			refetchQueries: [{ query: treeQuery, variables: { includeOutOfOrder: true } }]
		})
	}

	return(
		<ContentBlock>
			<Form
				smartSubmit
				initialValues={formData}
				onSubmit={handleSubmit}
			>
				<Row>
					<Col xs={5}>
						<ClientSelector lastNode='SHOP' field='shopId' {...notEmpty()}/>
						<Text field='name' label={t('options_section.fields.cash_register_name')} {...notEmpty()}/>
					</Col>
					<Col xs={5}>
						<Select
							field='priceLevelOut'
							label={t('options_section.fields.price_level')}
							options={priceOptions}
						/>
						<Select
							field='priceLevelIn'
							label={t('options_section.fields.price_level_in_house')}
							options={priceOptions}
						/>
						<Select
							field='mode'
							label={t('options_section.fields.mode')}
							options={[
								{ value: 0, label: `<${t('options_section.strings.standard')}>` },
								{ value: 100, label: t('common.strings.vat_normal') }
							]}
						/>
					</Col>
				</Row>
				{data.outOfOrder &&
					<>
						<Divider/>
						<Row>
							<Col xs>
								<StyledLabel>{t(`options_section.strings.cashregister_was_deactivated`)}</StyledLabel>
								<StyledLabel>{t(`options_section.fields.date`)}: {new Date(data.outOfOrderDate).toLocaleString()}</StyledLabel>
								<TextArea
									readOnly
									noForm
									value={data.outOfOrderReason}
									label={t('closing_section.strings.cancel_reason')}
									field='outOfOrderReason'
								/>
							</Col>
						</Row>
					</>
				}
			</Form>
		</ContentBlock>
	)
}

export default GeneralParams
